import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Spinner from '../Spinner';

const labelStyle: React.CSSProperties = {
  fontSize: '0.75rem',
  fontWeight: 600,
  color: '#6d7175',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  display: 'block',
  marginBottom: 4,
};

const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '7px 10px',
  border: '1px solid #e1e3e5',
  borderRadius: 6,
  fontSize: '0.85rem',
  color: '#202223',
  background: '#fff',
  outline: 'none',
};

const SettingsPage = () => {
  const [homePageMessage, setHomePageMessage] = useState('');
  const [closedDatesForPickup, setClosedDatesForPickup] = useState('');
  const [closedDatesForDelivery, setClosedDatesForDelivery] = useState('');
  const [loading, setLoading] = useState(true);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    axios
      .get('/api/admin/getSettings')
      .then((res) => {
        setHomePageMessage(res.data.homePageMessage || '');
        setClosedDatesForPickup(res.data.closedDatesForPickup || '');
        setClosedDatesForDelivery(res.data.closedDatesForDelivery || '');
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const handleSaveChanges = () => {
    console.log('Saving settings:', {
      homePageMessage,
      closedDatesForPickup,
      closedDatesForDelivery,
    });
    axios
      .post('/api/admin/updateSettings', {
        homePageMessage,
        closedDatesForPickup,
        closedDatesForDelivery,
      })
      .then(() => {
        setSaved(true);
        setTimeout(() => setSaved(false), 3000);
      })
      .catch(() => alert('Error updating settings.'));
  };

  return (
    <div className="admin-card">
      <div className="admin-card-header">
        <p className="admin-card-title">Settings</p>
      </div>

      {loading ? (
        <div className="admin-empty-state">
          <Spinner />
        </div>
      ) : (
        <div
          className="admin-card-body"
          style={{ display: 'flex', flexDirection: 'column', gap: 20, maxWidth: 600 }}
        >
          <div>
            <label style={labelStyle}>Home page message</label>
            <textarea
              style={{ ...inputStyle, minHeight: 100, resize: 'vertical' }}
              placeholder="Enter home page message"
              value={homePageMessage}
              onChange={(e) => setHomePageMessage(e.target.value)}
            />
          </div>

          <div>
            <label style={labelStyle}>Closed dates for pickup</label>
            <input
              style={inputStyle}
              placeholder="DD-MM-YYYY, DD-MM-YYYY, …"
              value={closedDatesForPickup}
              onChange={(e) => setClosedDatesForPickup(e.target.value)}
            />
          </div>

          <div>
            <label style={labelStyle}>Closed dates for delivery</label>
            <input
              style={inputStyle}
              placeholder="DD-MM-YYYY, DD-MM-YYYY, …"
              value={closedDatesForDelivery}
              onChange={(e) => setClosedDatesForDelivery(e.target.value)}
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <button
              className="admin-dropdown-trigger"
              onClick={handleSaveChanges}
              style={{ background: '#ec174f', color: '#fff', borderColor: '#ec174f' }}
            >
              Save changes
            </button>
            {saved && (
              <span className="status-badge confirmed" style={{ fontSize: '0.78rem' }}>
                Saved
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SettingsPage;
